import { FullProject, LoggedUser } from 'entities';

export function validateHasInvoiceAccess(project: FullProject, user: LoggedUser): boolean {
  const hasAccess = [
    project.owner.id === user.id,
    project.subOwner?.id === user.id,
    user.team.isInvoiceTeam,
    user.team.salesArea,
    user.isSysAdmin,
  ].some(Boolean);

  return hasAccess;
}
